import { createContext, ReactNode, useContext } from "react";

import { AllFulfillmentTypesType } from "@sellar-io/api-v2/types";

export type EntityAssignmentType = {
  connectionIds: number[];
  customerZoneIds: number[];
  setConnectionIds: React.Dispatch<React.SetStateAction<number[]>>;
  setCustomerZoneIds: React.Dispatch<React.SetStateAction<number[]>>;
  existingConnectionIds?: number[];
  existingCustomerZoneIds?: number[];
  currentListName: string;
  header: ReactNode;
  type?:
    | "product catalogue"
    | "price list"
    | "delivery method"
    | "volume discount";
  fulfillmentType?: Extract<
    AllFulfillmentTypesType,
    "haulier" | "direct" | "courier" | "sellarDistribution"
  >;
  hideCustomerZones?: boolean;
};

export type ItemType = {
  id: number;
  name: string;
  currentAssignment?: string | null;
};

export const EntityAssignmentContext = createContext<
  EntityAssignmentType | undefined
>(undefined);

export const useEntityAssignmentContext = () => {
  const context = useContext(EntityAssignmentContext);
  if (context === undefined) {
    throw new Error(
      "useEntityAssignmentContext must be within EntityAssignmentContextProvider",
    );
  }

  return context;
};
